export const messageErrorForm = {
  name: 'Introduce un nombre.',
  nameCommercial: 'Introduce un nombre comercial.',
  businessName: 'Introduce la razón social de la empresa.',
  lastName: 'Introduce los apellidos.',
  select: 'Selecciona una de las opciones.',
  password: {
    required: 'Introduce una contraseña.',
    notMatch: 'Las contraseñas no coinciden.',
    min: 'La contraseña debe tener mínimo 8 caracteres.',
    newPassword: 'Las nuevas contraseñas no coinciden.'
  },
  email: 'Introduce un correo electrónico.',
  country: 'Introduce el país donde está registrada la empresa.',
  phone: {
    required: 'Introduce el teléfono celular.',
    notMatch: 'El teléfono debe contener solo números',
    min: 'El teléfono debe tener minimo 10 dígitos'
  },
  businessPhone: {
    required: 'Introduce el teléfono celular.',
    notMatch: 'El teléfono debe contener solo números',
    min: 'El teléfono debe tener minimo 10 dígitos'
  },
  codeForgotPassword: {
    invalid: 'El código es incorrecto, intenta de nuevo.'
  },
  date: 'Selecciona una fecha.',

  identificationTypeAndNumber: 'Introduce el tipo y número de identificación.',
  identificationNumber: {
    notMatch: 'El NIT debe tener 10 caracteres (CON dígito de verificación, sin guión)',
    required: 'Introduce el número de identificación.'
  }
};

export const messageErrorFormChangePassword = {
  actualPassword: 'Esta no es la contraseña actual.'
};

export const messageErrorFormAccountBank = {
  bankAccountNumber: 'Introduce el número de cuenta.',
  paymentName: 'Introduce el nombre del titular de cuenta.',
  paymentLastName: 'Introduce el apellido del titular de cuenta.',
  businessName: 'Introduce la razón social del titular de cuenta.'
};

export const messageErrorFormCollaborator = {
  salary: {
    required: 'Introduce el saldo completo.',
    notMatch: 'El monto debe ser mayor que 0'
  },
  position: 'Introduce el cargo.',
  nameCollaborator: 'Introduce nombre colaborador.',
  lastNameCollaborator: 'Introduce apellido colaborador'
};

export const messageErrorNotItemSelected = {
  invoices: 'Selecciona una o más cuentas de cobro para continuar',
  agreement: 'Selecciona una o más empresa o servicio para continuar.',
  collaborator: 'Selecciona uno o más colaboradores para continuar'
};

export const messageErrorFormPurchases = {
  supplierName: 'Selecciona el proveedor.',
  issueDate: 'Introduce la fecha de creación de la cuenta de cobro.',
  item: {
    description: 'Introduce el nombre del item.',
    quantity: {
      required: 'Introduce la cantidad.',
      notMatch: 'La cantidad debe ser mayor que 0'
    },
    subtotal: 'Introduce el subtotal del item.'
  }
};
export const messageErrorFormCharge = {
  dueDate: 'Introduce la fecha de vencimiento del cobro'
};

export const messageErrorFormAgreement = {
  referenceId: 'Introduce el número de referencia o contrato.',
  agreementId: 'Selecciona una empresa o servicio.',
  description: 'Introduce una descripción'
};
